import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { InertiaLink } from '@inertiajs/inertia-react'
import EditIcon from '@mui/icons-material/Edit'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'

export default function POSIndex({ pos }) {
  const { t } = useTranslation()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('POS.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'address',
              Header: t('POS.ADDRESS'),
              accessor: 'address',
              type: 'string',
            },

            {
              id: 'city',
              Header: t('POS.CITY'),
              accessor: 'city',
              type: 'string',
            },
            {
              id: 'merchant_name',
              Header: t('POS.MERCHANT'),
              accessor: 'merchant_name',
              type: 'string',
              Cell: ({ row }) => (
                <div>{row.original.merchant_name ? row.original.merchant_name : t('POS.NOT_SET')}</div>
              ),
            },
            {
              id: 'actions',
              Header: t('POS.ACTIONS'),
              align: 'center',
              cell: {
                style: { whiteSpace: 'nowrap' },
              },
              disableFilters: true,
              Cell: ({ row }) => (
                <IconButton component={InertiaLink} href={route('admin.pos.edit', row.original.id)}>
                  <EditIcon />
                </IconButton>
              ),
            },
          ]}
          data={pos}
          enableCollapseFilter={false}
          routeName="admin.pos.index"
        />
      </Grid>
    </Grid>
  )
}
